(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var SELECTORS = [
    '[data-section-name="bnexo-product-spotlight"]',
    '[data-section-name="bnexo-single-cards"]',
    '[data-section-name="bnexo-about"]',
    '[data-section-name="bnexo-seo-page"]',
    '[data-section-name="bnexo-ecosystem"]',
    '[data-section-name="collection-list"]',
    '[data-section-name="text-columns-with-images"]',
    '[data-section-name="text"]',
    '[data-section-name="newsletter"]',
    '[data-section-name="main-collection-banner"]',
    '[data-section-name="main-collection-product-grid"]',
    '.bnexo-product-page .product-page-section'
  ];

  var nodes = [];
  SELECTORS.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (nodes.indexOf(el) === -1) {
        nodes.push(el);
      }
    });
  });

  nodes.forEach(function (el, index) {
    el.classList.add('bnexo-reveal');
    if (index % 3 === 1) {
      el.classList.add('bnexo-reveal--delay-1');
    } else if (index % 3 === 2) {
      el.classList.add('bnexo-reveal--delay-2');
    }
  });

  if (!('IntersectionObserver' in window)) {
    nodes.forEach(function (el) {
      el.classList.add('bnexo-reveal--visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bnexo-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.06,
      rootMargin: '0px 0px -32px 0px'
    }
  );

  nodes.forEach(function (el) {
    observer.observe(el);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    var inner = section.querySelector(SELECTORS.join(','));
    if (!inner) {
      return;
    }
    inner.classList.add('bnexo-reveal', 'bnexo-reveal--visible');
  });
})();
